import React from 'react';
import ProductCard from './ProductCard';
import { useHome } from '../context/HomeContext';
import { useNavigate } from 'react-router-dom';
import { API_CONFIG } from '../config/apiConfig';

const TrendingProducts = () => {
  const { homeData, loading, error } = useHome();
  const navigate = useNavigate();

  // Get products from homeData, defaulting to empty array
  const products = homeData?.topProducts || [];

  // Build tabs: 'All' + all subcategories from all main categories (using subCates)
  let subcategories = [];
  if (Array.isArray(homeData?.categories)) {
    homeData.categories.forEach(cat => {
      if (Array.isArray(cat.subCates)) {
        cat.subCates.forEach(sub => {
          subcategories.push({ id: String(sub.id), label: sub.name });
        });
      }
    });
  }
  // Remove duplicates by id
  const uniqueSubcategories = Object.values(
    subcategories.reduce((acc, sub) => {
      acc[sub.id] = sub;
      return acc;
    }, {})
  );
  const tabs = [
    { id: 'all', label: 'All' },
    ...uniqueSubcategories
  ];

  // Handle tab clicks - redirect to shop page with filtering
  const handleTabClick = (tabId) => {
    if (tabId === 'all') {
      // "All" tab - go to shop page without filters
      navigate('/shop');
    } else {
      // Find the subcategory by ID and navigate with category name
      const subcategory = uniqueSubcategories.find(sub => sub.id === tabId);
      if (subcategory) {
        // Special case for Seasonal Fruits - redirect to /inseason
        if (subcategory.label === 'Seasonal Fruits') {
          navigate('/inseason');
        } else {
          // For other subcategories, navigate to shop with category filter
          navigate(`/shop?category=${encodeURIComponent(subcategory.label)}`);
        }
      }
    }
  };

  return (
    <section className="product__section section--padding pt-0">
      <div className="container">
        <div className="section__heading text-center mb-25">
          <span className="section__heading--subtitle">Recently added our store</span>
          <h2 className="section__heading--maintitle">Trending Products</h2>
        </div>
        
        <ul className="product__tab--one product__tab--btn d-flex justify-content-center mb-35">
          {tabs.map((tab) => (
            <li 
              key={tab.id}
              className="product__tab--btn__list"
              onClick={() => handleTabClick(tab.id)}
            >
              {tab.label}
            </li>
          ))}
        </ul>

        <div className="tab_content">
          <div className="tab_pane active show">
            <div className="product__section--inner">
              <div className="row row-cols-lg-4 row-cols-md-3 row-cols-2 mb--n28">
                {products.slice(0, 8).map((product) => (  // Show first 8 products as preview
                  <div key={product.id} className="col mb-28">
                    <ProductCard product={product} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrendingProducts;
